/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Activity_Filter_PlanInputs */



/**
* | output |
* | --- |
* | "Plan changes" |
*
* @param {Partner_Activity_Filter_PlanInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_activity_filter_plan = /** @type {((inputs?: Partner_Activity_Filter_PlanInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Activity_Filter_PlanInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Tarifänderungen")
	return /** @type {LocalizedString} */ ("Plan changes")
});